import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import VKVideoEmbedPlayerModal from "@components/Common/VKVideo/VKVideoEmbedPlayerModal";
import VKVideoPlayerModal from "@components/Common/VKVideo/VKVideoPlayerModal";
import { DevModal } from "@components/Helpers";
import { validateYouTubeUrl } from "@components/Utils";
import ImagePreviewModal from "@screens/Game/Highlights/components/ImagePreviewModal";

function YoutubeModal({ embed, url }) {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const handleShow = () => setShow(true);

    return (
        <>
            {embed && (
                <img
                    onClick={handleShow}
                    className="img-thumbnail dev-listing-img"
                    src={`https://img.youtube.com/vi/${embed}/default.jpg`}
                    alt="image"
                    style={{ cursor: "pointer" }}
                />
            )}

            <DevModal
                show={show}
                onHide={handleClose}
                body={
                    <>
                        <iframe
                            frameBorder={0}
                            src={`https://www.youtube.com/embed/${embed}?autoplay=1&enablejsapi=1`}
                            allowFullScreen={true}
                            width="100%"
                            height="300px"
                        />
                        <div className="mt-3">
                            <span>{t("Ссылка")}:</span>{" "}
                            <a href={url} target="_blank" style={{ wordWrap: "break-word" }}>
                                {url}
                            </a>
                        </div>
                    </>
                }
                footer={
                    <Button variant="light" onClick={handleClose}>
                        {t("Закрыть")}
                    </Button>
                }
            />
        </>
    );
}

export default function ListItemImage({ data }) {
    const [imageUrl, setImageUrl] = useState();

    useEffect(() => {
        if (data?.vkvideo_id) {
            const thumb = data?.vkvideo_data?.thumbs.url_small;
            if (thumb) {
                setImageUrl(thumb);
            }
        } else if (data?.pic) {
            setImageUrl(data.pic);
        } else if (!data?.pic && data?.video && data?.video_pic) {
            setImageUrl(data.video_pic);
        }
    }, [data]);

    // Пришлось сделать поддержку youtube из-за ранее загруженных туда видео
    const youtubeEmbed = validateYouTubeUrl(data?.video);
    if (data?.video && youtubeEmbed) {
        return <YoutubeModal url={data?.video} embed={youtubeEmbed} />;
    }

    if (data?.vkvideo_id) {
        return <VKVideoPlayerModal data={data?.vkvideo_data} />;
    }

    if (data?.video) {
        return <VKVideoEmbedPlayerModal thumb={data?.video_pic} url={data?.video} />;
    }

    return <>{imageUrl ? <ImagePreviewModal url={imageUrl} /> : "-"}</>;
}
